import { initializeApp } from "firebase/app";

if ("serviceWorker" in navigator)
  navigator.serviceWorker.register("./firebase-messaging-sw.js");

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FBC_API_KEY,
  authDomain: process.env.VUE_APP_FBC_AUTHDOMAIN,
  projectId: process.env.VUE_APP_FBC_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FBC_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FBC_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FBC_APP_ID,
  measurementId: process.env.VUE_APP_FBC_MEASUREMENT_ID,
};

initializeApp(firebaseConfig)

